import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
import Vue from "vue";

export const productAssetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/quick-hierarchy/product-asset-group-category",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/quick-hierarchy/product-asset-group-category`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/quick-hierarchy/product-asset-group-category`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/quick-hierarchy/product-asset-group-category/${item._id}`);
          success.push(Vue.filter("translate")(item.assetGroupCategory.name) + "-" + item.products.join(", "));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.assetGroupCategory.name) + "-" + item.products.join(", "), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
export const workspaceProductAssetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/quick-hierarchy/product-asset-group-category",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/workspace/quick-hierarchy/product-asset-group-category`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/workspace/quick-hierarchy/product-asset-group-category`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/workspace/quick-hierarchy/product-asset-group-category/${item._id}`);
          success.push(Vue.filter("translate")(item.assetGroupCategory.name) + "-" + item.products.join(", "));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.assetGroupCategory.name) + "-" + item.products.join(", "), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
